export enum InviteUsersFailureDialogActions {
    OKAY = 'okay',
}
